import { Product } from '@core/models/piramide/Product';

export class CoolerCpu extends Product {
  $caracteristicas: {
    TDP: number;
    altura: number;
    altura_real: number;
    cantidad: number;
    color_iluminacion: string;
    cooler_base: number;
    espacios_120mm: number;
    espacios_140mm: number;
    fecha_update: string;
    id_producto: number;
    nro_coolers: number;
    ruido: null;
    ruido_max: number;
    sistema_rgb: null;
    sockets: string;
    tam_cooler: number;
    tipo_disipacion: string;
    tipo_gab: number;
    w: number;
  };
  public constructor(product: Product) {
    super(product);
  }
}
